<template lang="pug">
  .eventInfo(v-loading="isLoading")
    template(v-if="event")
      .info
        .bottons
          el-button(@click="openUpdateDialog" icon="el-icon-edit" size="mini")
          el-button(@click="isShowingEventDeleteDialog=true" icon="el-icon-delete" size="mini" type="danger")
        h1 {{ event.name }}
          el-tooltip(placement="right" :content="$t('Cuona.Event.tooltip01')")
            a(@click="copyEventToken(event.event_token)")
              i.el-icon-copy-document

        p.note(v-if="(event.description||'').length>0") {{ event.description }}
        p.events
          el-tag {{ $t(showActions(event.action_type)) }}
          a.link(v-if="event.action_data != null && event.action_data.url != null" :href="event.action_data.url" target="_blank") {{ event.action_data.url }}

      .groups
        h2 {{ $t('Cuona.Event.title03') }}
          span.count {{event.groups.length}}
        GroupsTable(:groups="event.groups" :edit="true" :loading="false" @openDialog="isShowingAddGroupsDialog=true")

      .devices
        h2 {{ $t('Cuona.Event.title04') }}
          span.count {{event.devices.length}}
        DevicesTable(:devices="event.devices" :edit="true" :loading="false" @openDialog="isShowingAddDevicesDialog=true")

    event-dialog(@eventUpdated="updateData")

    el-dialog(:title="$t('Cuona.Event.title01')" :visible.sync="isShowingEventDeleteDialog")
      p {{ $t('Cuona.Event.description02') }}
      .dialog-footer(slot="footer")
        el-button(@click="isShowingEventDeleteDialog=false" :disabled="isLoading") {{ $t('Cuona.Event.cancel') }}
        el-button(type="danger" @click="deleteEvent" :disabled="isLoading") {{ $t('Cuona.Event.delete') }}

    el-dialog(:title="$t('Cuona.Device.set_device')" width="65%" top="8vh" :visible.sync="isShowingAddDevicesDialog" @closed="closedAddDevicesDialog")
      el-form(label-position="left" :rules="rules" label-width="140px" ref="addDevicesDialogForm" :model="dialogForm" v-loading="isLoading")
        .content
          el-table(ref="addDevicesTable" :data="devices" @row-click="toggleAddDevices" @selection-change="setSelectedDevices" cell-class-name="el-table-cell" row-class-name="el-table-row" max-height="300")
            el-table-column(type="selection" width="55")
            el-table-column(prop="name" :label="$t('Cuona.Device.name')" sortable="")
              template(slot-scope="props")
                img.device-image(:src="getCuonaImage(props.row)")
                span {{ props.row.name }}
            el-table-column(width="180px" prop="nfc_uid" :label="$t('Cuona.Device.id')" sortable="")
            el-table-column(prop="groups" :label="$t('Cuona.Event.group')" sortable="")
              template(slot-scope="props")
                template(v-for="group in props.row.groups")
                  el-tag.group(size="mini") {{ group.name }}
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingAddDevicesDialog=false" :disabled="isLoading") {{ $t('Cuona.Event.cancel') }}
        el-button(type="primary" @click="addDevices" :disabled="isLoading") {{ $t('Cuona.Event.update') }}

    el-dialog(:title="$t('Cuona.Group.set_group')" width="65%" top="8vh" :visible.sync="isShowingAddGroupsDialog" @closed="closedAddGroupsDialog")
      el-form.form(label-position="left" label-width="120px" ref="addGroupsDialogForm" v-loading="isLoading")
        .content
          el-table(ref="eventGroupTable" :data="groups" @row-click="toggleGroup" @selection-change="setSelectedGroups" cell-class-name="el-table-cell" row-class-name="el-table-row")
            div.empty(slot="empty")
              img(:src="images.group_empty")
              p(v-html="nl2br($t('Cuona.Event.description07'))")
            el-table-column(type="selection" width="35")
            el-table-column(width="250px" prop="name" :label="$t('Cuona.Group.name')" sortable="")
            el-table-column(prop="manager.name" :label="$t('Cuona.Group.manager')" sortable="")
            el-table-column(width="130px" prop="devices.length" :label="$t('Cuona.Group.cuona_num')" sortable="" align="center")
            el-table-column(prop="description" :label="$t('Cuona.Group.note')")
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingAddGroupsDialog=false" :disabled="isLoading") {{ $t('Cuona.Group.cancel') }}
        el-button(type="primary" @click="addGroups" :disabled="isLoading") {{ $t('Cuona.Group.change') }}
</template>

<script>
import DevicesTable from '../DevicesTable'
import GroupsTable from '../GroupsTable'
import { mapState } from 'vuex'
import EventApi from '@/api/event'
import GroupApi from '@/api/group'
import DeviceApi from '@/api/cuona'
import actions from '@/utils/defines/actions.js'
import EventDialog from './EventDialog'
export default {
  mixins: [actions],
  components: {
    DevicesTable,
    GroupsTable,
    'event-dialog': EventDialog
  },
  data () {
    return {
      event: null,
      groups: [],
      devices: [],
      selectedGroups: [],
      isShowingAddGroupsDialog: false,
      isShowingAddDevicesDialog: false,
      isShowingEventDeleteDialog: false,
      isLoading: false,
      dialogForm: {
        name: '',
        actionType: null,
        description: '',
        selectedGroupIds: [],
        selectedDevices: [],
        url: ''
      },
      images:{
        group_empty: require('@/assets/empty_event_group.svg'),
        device_empty: require('@/assets/device_empty.svg'),
        cube: require('@/assets/cuona_cube.svg'),
        tag: require('@/assets/cuona_seal.svg')
      },
      selectedCoupon: null,
      rules: {
        name: [
          { required: true, message: this.$t('Cuona.Event.description03'), trigger: 'blur' }
        ],
        actionType: [
          { required: true, message: this.$t('Cuona.Event.description04'), trigger: 'change' }
        ]
      },
    }
  },
  mounted() {
    this.updateData();
  },
  computed: {
    ...mapState({
      coupons: state => state.plugin.coupons
    }),

    nfcUidsInEvent: function() {
      return this.event.devices.map(function(device) {
        return device.nfc_uid
      });
    },

    groupIdsInEvent: function() {
      return this.event.groups.map(function(group) {
        return group.id
      });
    },

    // イベント更新時に選択したデバイスID一覧
    selectedNfcUids: function() {
      return this.dialogForm.selectedDevices.map(function(selectedDevice) {
        return selectedDevice.nfc_uid
      });
    },
  },
  watch : {
    event : function() {
      if(this.event) {
        this.$store.commit('setLastBreadcrumb', this.event.name);
        this.setPageTitle(this.event.name);
      }
    },
  },
  methods: {
    updateData() {
      this.getEventGroupsDevices(this.$route.params.id);
    },
    getEventGroupsDevices: function (id){
      this.isLoading = true;
      const that = this;
      Promise.all([EventApi.getEvent(id), GroupApi.getGroups(), DeviceApi.getDevices()])
        .then(function(values) {
          that.event = values[0];
          that.groups = values[1];
          that.devices = values[2];
        })
        .catch((error) => {
          this.$router.replace('/cuona/event');
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    toggleAddDevices: function(row, event, column) {
      this.$refs.addDevicesTable.toggleRowSelection(row);
    },

    toggleGroup: function(row, event, column) {
      this.$refs.eventGroupTable.toggleRowSelection(row);
    },

    // グループ作成時にチェックされたCUONA一覧を取得
    setSelectedDevices(val) {
      this.dialogForm.selectedDevices = val;
    },

    setSelectedGroups(selectedGroups) {
      this.selectedGroups = selectedGroups;
    },

    // アクション名を一致させる処理
    showActions: function(action_name) {
      for(var i=0; i<this.actions.length; i++){
        if (this.actions[i].type == action_name){
          return this.actions[i].name;
        }
      }
    },

    copyEventToken: function(token) {
      let temp = document.createElement('textarea')
      temp.value = token
      temp.selectionStart = 0
      temp.selectionEnd = temp.value.length

      var s = temp.style
      s.position = 'fixed'
      s.left = '-100%'

      document.body.appendChild(temp)
      temp.focus()
      let result = document.execCommand('copy')
      temp.blur()
      document.body.removeChild(temp)

      if (result) {
        this.$message({
          showClose: true,
          message: this.$t('Clipboard.copySuccessful'),
          type: 'success'
        })
      } else {
        this.$message({
          showClose: true,
          message: this.$t('Clipboard.copyFailed'),
          type: 'error'
        })
      }
    },

    // イベントの削除
    deleteEvent: function() {
      this.isLoading = true;
      EventApi.deleteEvent(this.event.id)
        .then((event) => {
          this.$router.replace('/cuona/event');
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.description06'),
            type: 'success'
          });
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.failed_delete'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    addGroups: function() {
      const selectedGroupIds = [];
      if(0 < this.selectedGroups.length) {
        this.selectedGroups.forEach(function(selectedGroup) {
          selectedGroupIds.push(selectedGroup.id);
        });
      }
      const payload = {
        eventId: this.event.id,
        params: {
          nfc_uids: this.nfcUidsInEvent,
          group_ids: selectedGroupIds
        }
      }
      this.callUpdateEventApi(payload);
    },

    addDevices: function() {
      const payload = {
        eventId: this.event.id,
        params: {
          nfc_uids: this.selectedNfcUids,
          group_ids: this.groupIdsInEvent
        }
      }
      this.callUpdateEventApi(payload);
    },

    callUpdateEventApi: function(payload) {
      this.isLoading = true;
      EventApi.updateEvent(payload)
        .then((event) => {
          this.event = event;
          this.isShowingAddDevicesDialog = false;
          this.isShowingAddGroupsDialog = false;
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.description11'),
            type: 'success'
          });
        })
        .catch((error) => {
          let errorMessage = 'Cuona.Event.failed_update';
          switch(error.code) {
            case 409:
              errorMessage = 'Cuona.Event.has_dup_name_event';
              break;
          }
          this.$message({
            showClose: true,
            message: this.$t(errorMessage),
            type: 'error'
          });
        }).finally(() => { this.isLoading = false; });
    },

    // CUONAのアイコンを設定
    getCuonaImage: function(device) {
      if(device.is_development) {
        return this.images.dev
      } else if(device.device_type == 'tag') {
        return this.images.tag
      } else {
        return this.images.cube
      }
    },

    closedAddGroupsDialog: function() {
      this.$refs['addGroupsDialogForm'].resetFields();
      this.$refs.eventGroupTable.clearSelection();
    },

    closedAddDevicesDialog: function() {
      this.$refs['addDevicesDialogForm'].resetFields();
      this.$refs.addDevicesTable.clearSelection();
    },
    openUpdateDialog() {
      this.$store.dispatch('showEventDialog', this.event.id);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";
@import "../../../styles/table-layout.scss";

.group-select {
  width: 100%;
}

.el-dialog .content {
  margin: 0;
}

.eventInfo {
  min-height: 20vh;
  background: #FFF;
  border-radius: 5px;
  margin: 40px;
  padding: 0;
  border: 1px solid $border;
}

.info {
  padding-bottom: 30px;

  h1 {
    padding: 0 40px;
    margin:  30px 0 0 0;
    font-size: 24px;
    font-weight: normal;

    .el-tooltip {
      font-size: 16px;
      margin-left: 5px;
      text-align: baseline;
      cursor: pointer;
    }
  }

  h2 {
    padding: 0 40px;
    margin: 30px 0 10px 0;
    font-size: 18px;
    font-weight: 500;
  }

  h3 {
    padding: 0 40px;
    margin-bottom: 3px;
    font-size: 16px;
    font-weight: normal;
  }
}

.bottons {
  margin: -20px 10px 0 0;
  float: right;
}

.eventInfo {
  padding-bottom: 5px;
}

p.events {
  padding: 0 40px;
  font-size: 14px;
}

a {
  transition: all .3s ease-in-out;
  color: #666;
  &:hover {
    color: $safe;
  }
}

a.link {
  margin-left: 10px;
  display: inline-block;
  color: $safe;
  border-radius: 20px;
  padding: 2px 10px;
  transition: all .3s ease-in-out;

  &:hover {
    background: $border;
  }
}

p.note {
  padding: 0 40px;
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #999;
}

.groups, .devices {
  border-top: 1px solid $border;
  padding: 0 30px 40px 30px;

  h2 {
    margin: 30px 0 10px 10px;
    font-size: 16px;
    font-weight: 500;
  }

  .el-table ::v-deep {

    th {
      font-weight: normal;
      font-size: 12px;
      padding: 0;
      color: #999;
    }

    td {
      font-size: 13px;
    }
  }
}

span.count {
  display: inline-block;
  text-align: center;
  background: $border;
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 15px;
  margin-left: 8px;
}

</style>
